var blocks = document.querySelectorAll(".acf-carousel, .acf-hero.has-carousel .media--carousel");
blocks.forEach(function (block) {
	const carousel = block.querySelector(".items");
	const slides = block.querySelectorAll(".items > *");

	if (!slides.length || slides.length === 0) {
		return false;
	}

	const controls = block.querySelector(".controls");

	const pager = block.querySelector(".pager");

	const toggleButton = block.querySelector("[data-play-pause]");
	const prevButton = block.querySelector("[data-direction='previous']");
	const nextButton = block.querySelector("[data-direction='next']");

	const slideObserverSettings = {
		root: carousel,
		rootMargin: "-20px",
	};

	let autoplay = false;

	/**
	 * Get make elements focusable
	 * @source ?
	 * @param  {NodeList} elements the group of elements
	 * @param  {Boolean} focusable whether they should be made focusable or not
	 * @return {Boolean}
	 */
	function makeElementsFocusable(elements, focusable) {
		elements.forEach(function (element) {
			if (focusable === false) {
				element.removeAttribute("tabindex");
			} else {
				element.setAttribute("tabindex", "-1");
			}
		});
	}

	/**
	 * Get focusable elements within a container
	 * @source Andy Bell?
	 * @param  {Element} parent The HTML Element
	 * @return {Boolean}
	 */
	function getFocusableElements(element) {
		if (!element) {
			console.warn("You need to pass an HTMLElement");
			return [];
		}

		return element.querySelectorAll(
			'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
		);
	}

	/**
	 * Convert an HTML element to a button
	 * @url https://justmarkup.com/articles/2019-01-21-the-link-to-button-enhancement/
	 * @param  {Element} element The HTML Element
	 * @return {Boolean}
	 */
	function convertElementToButton(element) {
		if (null !== element) {
			const elementHTML = element.innerHTML;
			const elementAtts = element.attributes;
			const button = document.createElement("button");

			// copy button attributes and content from link
			button.innerHTML = elementHTML.trim();
			for (count = 0, len = elementAtts.length; count < len; count++) {
				let attr = elementAtts[count];
				if ("href" !== attr.name) {
					button.setAttribute(attr.name, attr.value);
				}
			}
			element.replaceWith(button);

			return button;
		}

		return element;
	}

	function elementIsVisible(element) {
		return element.classList.contains("is-visible");
	}

	function goToSlide(element, customArgs) {
		let scrollArgs;
		let defaultScrollArgs = {
			behavior: "auto",
			block: "center",
			inline: "center",
		};

		if (customArgs) {
			scrollArgs = Object.assign(defaultScrollArgs, customArgs);
		} else {
			scrollArgs = defaultScrollArgs;
		}

		try {
			element.scrollIntoView(scrollArgs);
		} catch (error) {
			// fallback to prevent browser crashing
			element.scrollIntoView(false);
		}
	}

	function autoplayAllowed() {
		const media_query = window.matchMedia("(prefers-reduced-motion: no-preference)");
		if (media_query.matches) {
			return true;
		}

		if (carousel.dataset.autoplay) {
			return true;
		}

		return false;
	}

	function updateToggleButtonLabel() {
		if (toggleButton == null) {
			return false;
		}
		var button_label = toggleButton.querySelector(".label");
		var pause_text = toggleButton.dataset.pauseLabel;
		var play_text = toggleButton.dataset.playLabel;

		switch (autoplay) {
			case true:
				toggleButton.classList.add("is-playing");

				toggleButton.title = button_label.innerText = pause_text;
				break;

			case false:
				toggleButton.classList.remove("is-playing");

				toggleButton.title = button_label.innerText = play_text;
				break;
		}
	}

	function disableAutoplay() {
		autoplay = false;

		updateToggleButtonLabel();
	}

	function enableAutoplay() {
		if (!autoplayAllowed()) {
			return false;
		}

		carousel.addEventListener(
			"pointerdown",
			() => {
				disableAutoplay();
			},
			{
				once: true,
			}
		);

		autoplay = true;

		updateToggleButtonLabel();
	}

	function autoplaySlides() {
		if (!autoplay) {
			return false;
		}

		var visibleSlides = carousel.querySelectorAll(".is-visible");
		if (visibleSlides.length > 0) {
			var finalVisibleSlide = visibleSlides[visibleSlides.length - 1];
			var nextSlide = finalVisibleSlide.nextElementSibling;

			if (nextSlide === null) {
				// We are on the final slide
				goToSlide(slides[0], {
					// behavior: "instant",
					behavior: "auto",
				});
			} else {
				goToSlide(nextSlide);
			}
		}
	}

	function removeActiveSlide(slide) {
		let id = slide.getAttribute("id");

		// Set all links to be non-interactive
		let slide_links = getFocusableElements(slide);
		makeElementsFocusable(slide_links);

		// Remove class
		slide.classList.remove("is-visible");

		// Remove active pager dot class
		if (pager != null) {
			let pager_button = pager.querySelector("[data-slide='" + id + "']");
			if (pager_button != null) {
				pager_button.classList.remove("is-active");
			}
		}
	}

	function addActiveSlide(slide) {
		let id = slide.getAttribute("id");

		// Set all links to be interactive
		let slide_links = getFocusableElements(slide);
		makeElementsFocusable(slide_links);

		// Add class
		slide.classList.add("is-visible");

		// Set active pager dot class
		if (pager != null) {
			let pager_button = pager.querySelector("[data-slide='" + id + "']");
			if (pager_button != null) {
				pager_button.classList.add("is-active");
			}
		}

		// Disable buttons if first/last slide
		if (prevButton != null) {
			prevButton.removeAttribute("disabled");

			if (slide.matches(":first-child")) {
				prevButton.setAttribute("disabled", "disabled");
			}
		}
		if (nextButton != null) {
			nextButton.removeAttribute("disabled");

			if (slide.matches(":last-child")) {
				nextButton.setAttribute("disabled", "disabled");
			}
		}
	}

	function observeSlides(slides) {
		Array.prototype.forEach.call(slides, function (entry) {
			var slide = entry.target;
			// console.log(slide);
			// console.log(entry);

			removeActiveSlide(slide);

			if (entry.isIntersecting) {
				addActiveSlide(slide);
			}
		});
	}

	function setupCarousel() {
		// Set basics for the carousel
		carousel.setAttribute("role", "region");
		carousel.setAttribute("tabindex", "0");
		carousel.classList.add("js-active");
	}

	function setupSlides() {
		// Add IDs to slides for pager buttons to use
		slides.forEach(function (slide, index) {
			if (!slide.hasAttribute("id")) {
				const slide_number = index + 1;
				slide.setAttribute("id", carousel.dataset.itemPrefix + "-" + slide_number);
			}
		});

		// Add observer of slides changing
		var slideObserver = new IntersectionObserver(observeSlides, slideObserverSettings);
		Array.prototype.forEach.call(slides, function (slide) {
			return slideObserver.observe(slide);
		});
	}

	function setupPager() {
		if (pager == null) {
			return false;
		}

		var pager_links = pager.querySelectorAll("a[data-slide]");
		if (pager_links.length == 0) {
			createPagerButtons();

			return false;
		}

		pager_links.forEach(function (element) {
			element = convertElementToButton(element);

			setupPagerButton(element);
		});
	}

	function setupPagerButton(button) {
		button.addEventListener("click", function (event) {
			event.preventDefault();

			disableAutoplay();

			var targetSlideID = button.getAttribute("data-slide");
			var targetSlide = block.querySelector("#" + targetSlideID);

			goToSlide(targetSlide);
		});
	}

	function createPagerButtons() {
		slides.forEach(function (slide, index) {
			console.log(slide);
			const target_slide = slide.getAttribute("id");
			const target_slide_number = index + 1;

			const button_text = "Go to Slide " + target_slide_number;

			const button = document.createElement("button");

			// copy button attributes and content from link
			button.classList.add("button", "button-style-fill");

			button.setAttribute("data-slide", target_slide);
			button.setAttribute("title", button_text);

			setupPagerButton(button);

			pager.appendChild(button);
		});
	}

	function setupDirectionalButtons() {
		if (prevButton != null) {
			prevButton.addEventListener("click", function (event) {
				disableAutoplay();

				var slideChanged = false;
				slides.forEach(function (slide, index) {
					var prevSlide = slides[index - 1];
					if (prevSlide === undefined) {
						return;
					}

					if (elementIsVisible(slide) && !elementIsVisible(prevSlide) && !slideChanged) {
						goToSlide(prevSlide);
						slideChanged = true;
					}
				});
			});
			prevButton.removeAttribute("hidden");
		}

		if (nextButton != null) {
			nextButton.addEventListener("click", function (event) {
				disableAutoplay();

				var slideChanged = false;
				slides.forEach(function (slide, index) {
					var nextSlide = slides[index + 1];
					if (nextSlide === undefined) {
						return;
					}
					if (elementIsVisible(slide) && !elementIsVisible(nextSlide) && !slideChanged) {
						goToSlide(nextSlide);
						slideChanged = true;
					}
				});
			});
			nextButton.removeAttribute("hidden");
		}
	}

	function startAutoplay() {
		if (toggleButton == null) {
			return false;
		}
		if (!autoplayAllowed()) {
			return false;
		}

		// Add observer of carousel to pause once it's out of view
		var carouselObserver = new IntersectionObserver(
			function (elements, observer) {
				elements.forEach(function (element) {
					if (!element.isIntersecting) {
						disableAutoplay();
					} else {
						enableAutoplay();
					}
				});
			},
			{ threshold: 1 }
		);
		carouselObserver.observe(carousel);

		enableAutoplay();
		setInterval(autoplaySlides, carousel.dataset.autoplayTiming || 7400);
	}

	function setupToggleButton() {
		if (!autoplayAllowed()) {
			return false;
		}
		if (toggleButton == null) {
			return false;
		}

		toggleButton.addEventListener("click", function (event) {
			if (autoplay) {
				disableAutoplay();
			} else {
				enableAutoplay();
			}
		});
		toggleButton.removeAttribute("hidden");
	}

	function setup() {
		// We don't need to do anything if there's only one slide
		if (slides.length <= 1) {
			return false;
		}

		// We need intersection observer for this to work
		if ("IntersectionObserver" in window) {
		} else {
			return false;
		}

		setupCarousel();
		setupSlides();
		setupPager();
		setupDirectionalButtons();
		setupToggleButton();

		startAutoplay();
	}

	setup();
});
